import 'core-js/stable';
import 'regenerator-runtime/runtime';

import $ from 'jquery';

/**
 * DOMContentLoaded
 */
$(document).ready(function() {
  'use strict';

  var $madomoFilter = $('.madomoFilter [data-filter]'),
    $madomolist = $('.madomolist [data-category]');

  $madomoFilter.on('click', function(e) {
    e.preventDefault();
    var $this = $(this);

    $madomoFilter.removeClass('active');
    $this.addClass('active');

    var $filterColor = $this.attr('data-filter');

    if ($filterColor == 'all') {
      $madomolist
        .removeClass('is-animated')
        .fadeOut()
        .promise()
        .done(function() {
          $madomolist.addClass('is-animated').fadeIn();
        });
    } else {
      $madomolist
        .removeClass('is-animated')
        .fadeOut()
        .promise()
        .done(function() {
          $madomolist
            .filter('[data-category~="' + $filterColor + '"]')
            .addClass('is-animated')
            .fadeIn();
        });
    }
  });
});
